import { useEffect } from 'react';

import { Customer } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useCustomer = (id: string) => {
  const result = apiClient.customer.getCustomer.useQuery(
    ['customer', id],
    { params: { id } },
    {
      queryKey: ['customer', id],
      enabled: !!id,
    },
  );
  useEffect(() => {
    if (result.isError) {
      showErrorToast(result.error, 'Failed to fetch customer details');
    }
  }, [result.isError, result.error]);
  return { ...result, data: result.data?.body?.data as Customer };
};
